import { useNavigate } from "react-router-dom";
import { CustomButton } from "../../../../components";
import { IoIosArrowRoundForward } from "react-icons/io";
import styles from "./PayNow.module.scss";
import EMIsAPI from "../../../../services/emi-api";
import { redirectToExternalURL } from "../../../../utils/utils";
import { getIsLentraCustomer, getLeadID, getProductId } from "../../../../utils/storage";

export default function PayNow(props) {
  const navigate = useNavigate();
  const isLentraCustomer = getIsLentraCustomer();
  const { loanSummary, disabled = false } = props;
  const  getProduct = Number(getProductId())
  const api = new EMIsAPI();

  const lentraRepayment = async (payload) => {
    try {
      const res = await api.getLentraFundIn(payload);
      const { statusCode, data } = res;

      if (statusCode === 200 && data?.url) {
        redirectToExternalURL(data.url);
      }
    } catch (error) {
      console.error("Lentra Repayment Error:", error);
    }
  };
  const handlePaymentOrder = () => {
    if (isLentraCustomer === true || isLentraCustomer === "true") {
     if(getProduct === 1){
        navigate("/re-payment", { state: { isForeClosure:false } });
        return;
        } 
      lentraRepayment({
        amount: Number(loanSummary?.amountToBeRepayed),
        leadID: getLeadID(),
      });
    } else {
      navigate("/re-payment");
    }
  };

  return (
    <div className={styles.totalAmount}>
      <div>
        <p>Total</p>
        <h5>₹{loanSummary?.amountToBeRepayed}</h5>
        <span className={styles.taxText}>Inclusive of all taxes</span>
      </div>
      <div>
        <CustomButton disabled={disabled} floating={false} text="Pay Now" endIcon={<IoIosArrowRoundForward size={30} />} onClick={handlePaymentOrder} />
      </div>
    </div>
  );
}
